import {useEffect, useRef, useState} from 'react';
// @ts-expect-error - react-color doesn't have type definitions
import {SketchPicker} from 'react-color';
import styles from './color-picker.module.scss';

interface ColorPickerProps {
  value?: string;
  onChange?: (color: string) => void;
  placeholder?: string;
}

const ColorPicker = ({value, onChange, placeholder = 'Select a color'}: ColorPickerProps) => {
  const [color, setColor] = useState(value || '');
  const detailsRef = useRef<HTMLDetailsElement>(null);
  const summaryRef = useRef<HTMLElement>(null);
  const colorPickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (value !== undefined) {
      setColor(value);
    }
  }, [value]);

  const handleChangeComplete = (colorResult: {hex: string}) => {
    setColor(colorResult.hex);
    onChange?.(colorResult.hex);
  };

  const handleClickOutsideDetails = (evt: MouseEvent) => {
    if (colorPickerRef.current && !colorPickerRef.current.contains(evt.target as Node)) {
      if (detailsRef.current) {
        detailsRef.current.open = false;
      }
    }
  };

  const onDetailsClick = (evt: React.MouseEvent<HTMLDetailsElement>) => {
    const target = evt.currentTarget;
    if (target.open && evt.target === summaryRef.current) {
      evt.preventDefault();
      target.open = false;
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDetails);
    return () => {
      document.removeEventListener('click', handleClickOutsideDetails);
    };
  }, []);

  return (
    <div className={styles.container}>
      <details ref={detailsRef} onClick={onDetailsClick}>
        <summary
          ref={summaryRef}
          className={styles.summary}
          style={{backgroundColor: color || undefined}}
        >
          {color || placeholder}
        </summary>
        <div ref={colorPickerRef} className={styles.pickerWrapper}>
          <SketchPicker
            color={color}
            onChangeComplete={handleChangeComplete}
          />
        </div>
      </details>
    </div>
  );
};

export default ColorPicker;
